"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var warning_1 = __importDefault(require("warning"));

var Select_1 = __importDefault(require("@material-ui/core/Select"));

var Select = function Select(_a) {
  var MenuProps = _a.MenuProps,
      input = _a.input,
      labelWidth = _a.labelWidth,
      props = __rest(_a, ["MenuProps", "input", "labelWidth"]);

  var inputProps = props.inputProps,
      multiple = props.multiple,
      native = props.native,
      SelectDisplayProps = props.SelectDisplayProps,
      variant = props.variant;

  if (!multiple && native) {
    warning_1.default(inputProps && inputProps.id, 'Unifi: Selects defined as "native" require inputProps to define an id. The id should be referenced by InputLabel in the htmlFor prop. Exception: custom input component with id defined. For a working, accessible example, see https://unifi.nelnet.io/components/forms/selects');
  }

  if (multiple && !native) {
    warning_1.default(SelectDisplayProps && SelectDisplayProps['aria-label'], 'Unifi: Selects defined as "multiple" require SelectDisplayProps with "aria-label" structured as: "aria-label": `[Label value]. ${this.state.value}`. For a working, accessible example, see https://unifi.nelnet.io/components/forms/selects#multiple-select');
  }

  var ariaMultiple = multiple || false;
  var menuProps = {
    MenuListProps: {
      'aria-multiselectable': ariaMultiple
    },
    BackdropProps: {
      'aria-hidden': !ariaMultiple,
      'aria-label': 'Close',
      role: 'button',
      style: {
        backgroundColor: 'transparent'
      }
    }
  };
  var mergedMenuProps = Object.assign(Object.assign({}, menuProps), MenuProps);
  var selectDisplayProps = {
    role: 'combobox'
  };
  var mergedSelectDisplayProps = Object.assign(Object.assign({}, selectDisplayProps), SelectDisplayProps);
  var outlinedLabelWidth = labelWidth;

  if (variant === 'outlined' && !labelWidth) {
    outlinedLabelWidth = 80;
  }

  return React.createElement(Select_1.default, Object.assign({}, props, {
    MenuProps: mergedMenuProps,
    SelectDisplayProps: mergedSelectDisplayProps,
    labelWidth: outlinedLabelWidth
  }));
};

exports.default = Select;